import React from 'react';
import * as TablerIcons from '@tabler/icons-react';

const TIcon = ({ name, size = 24, color = 'black', stroke = 2, className = '' }) => {
    const iconName = `Icon${name.charAt(0).toUpperCase()}${name.slice(1).replace(/-./g, x => x[1].toUpperCase())}`;
    const IconComponent = TablerIcons[iconName];

    return (
        IconComponent ? (<IconComponent
            size={size}
            color={color}
            stroke={stroke}
            className={className}
        />) : (null)

    );
}
export default TIcon